import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function Urgency() {
  return <div className="bg-white pt-12 pb-4" data-id="element-137">
      <div className="max-w-4xl mx-auto px-6" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex flex-col sm:flex-row items-center justify-center gap-3 text-center sm:text-left shadow-sm" data-id="element-139">
          <motion.div animate={{
          scale: [1, 1.1, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} data-id="element-140">
            <Clock className="w-6 h-6 text-amber-600" data-id="element-141" />
          </motion.div>
          <p className="text-amber-800 font-medium text-sm sm:text-base" data-id="element-142">
            <span className="font-bold" data-id="element-143">Cupos limitados:</span> Solo quedan 15
            consultas gratuitas este mes.
          </p>
        </motion.div>
      </div>
    </div>;
}